module.exports = __webpack_public_path__ + "img/4e8b81e.jpg";